const service = '/healths';
const service2 = '/basic-data';
const userInfo = {
  sendVerifyCode: service + '/mobile/auth',
  queryPatientsInfo: service + '/patients/info',
  bindPatientsInfo: service + '/patients/bind',
  queryProvinceList: service2 + '/position/provinces',
  queryCityList: service2 + '/position/cities',
  queryDistrictList: service2 + '/position/counties',
  queryTownList: service2 + '/position/towns',
  signatureCode: service + '/mobile/signature'
}

export default userInfo



// WEBPACK FOOTER //
// ./src/apis/services/userInfo.js